
<template>
    <form @submit.prevent="productSelected" class="uploader-product-step">
            <div class="uploader-product-options uploader-field-grid">
                <div class="uploader-field">
                    <label for="uploader-material">{{ $t('design_material') }}</label>
                    <select id="uploader-material" v-model="selected_product_group" @change="productGroupChanged()">
                        <option disabled :value="null">{{ $t('select') }}</option>
                        <option v-for="(product_group) in product_groups" v-bind:key="product_group.id" v-bind:value="product_group">{{ product_group.name }}</option>
                    </select>
                </div>
                <div class="uploader-field">
                    <label for="uploader-size">{{ $t('design_size') }}</label>
                    <select id="uploader-size" v-model="selected_product" :disabled="!selected_product_group" @change="productChanged()">
                        <option disabled :value="null">{{ $t('select') }}</option>
                        <option v-for="(product) in selectedProductGroupProducts" v-bind:key="product.id" v-bind:value="product">{{ product.name }}</option>
                    </select>
                </div>
            </div>
        <div class="uploader-room-preview">
            <canvas id="previewCanvas" width="1200" height="710" :aria-label="$t('design_room_preview')" role="img"></canvas>
            <div style="position:absolute; bottom:20px; right:20px; width: 27%; max-width:200px; padding: 8px; background: rgba(39, 43, 47, 0.6); border-radius:4px;" v-if="hasSelectedProductGroup">
                <img :src="this.selected_product_group.image_url" :alt="this.selected_product_group.name" width="100%" style="border-radius:4px;">
            </div>
        </div>
        <div>
            <div class="alert-uploader" role="alert" v-show="!this.isValid">{{ $t('no_material_or_size_selected') }}</div>
        </div>
        <p class="uploader-note">{{ $t('product_can_be_changed_afterwards') }} {{ $t('custom_size_wanted') }}</p>
        <div class="uploader-actions">
            <button type="button" class="btn-uploader btn-uploader-dark" :disabled="isSending" v-on:click="$store.dispatch('DECREMENT')"><span aria-hidden="true">←</span>{{ $t('back') }}</button>
            <button type="submit" class="btn-uploader" :disabled="isSending">{{ $t('design_next_contact') }}<span aria-hidden="true">→</span></button>
        </div>
    </form>
</template>

<script>
    import PreviewService from "@/services/preview.service";
    import UploadLog from "@/services/upload-log.service";

    const uploaderAssetBaseUrl = window.mmmUploaderConfig?.assetBaseUrl || process.env.BASE_URL;

    export default {
        name: "StepThree",
        data: function() {
            return {
                selected_product_group: null,
                selected_product_id: null,
                selected_product: null,
                isLoaded: false,
                isDesktop: false,
                isValid: true,
                isSending: false,
                image: {
                    naturalWidth: 0,
                    naturalHeight: 0,
                    aspectRatio: 0
                },
                image_style: {
                    position: "absolute",
                    left: "50%",
                    top: "50%",
                    marginLeft: "0%",
                    marginTop: "0%",
                    width: "20%", // 100% / 200 (sofa ist 2m breit) * 40 (Bildbreite)
                    height: "47%", // 100% / 127 (Wand über dem Sofa ist so hoch) * 60 (Bildhöhe)
                    //border: "1px solid #666"
                }
            }
        },
        computed: {
            hasSelectedProductGroup: function() {
                return this.selected_product_group !== null;
            },
            selectedProductGroupProducts: function() {
                return this.selected_product_group?.products || [];
            }
        },
        methods: {
            productSelected: function() {
                var vm = this;
                if(this.selected_product !== null && !vm.isSending) {
                    vm.isSending = true;
                    UploadLog.log('product_selected', {
                        product_id: this.selected_product.id,
                        sku: this.selected_product.sku,
                        product_group: this.selected_product_group ? this.selected_product_group.name : null
                    });
                    PreviewService.update({
                        code: this.$store.getters.preview,
                        product_id: this.selected_product.id
                    }).then(function () {
                        vm.$store.dispatch('INCREMENT');
                        vm.isValid = true;
                        vm.isSending = false;
                    }).catch(function(error) {
                        console.log((error.response && error.response.data) ||
                            error.message ||
                            error.toString());
                        UploadLog.logError('product_update_failed', error);
                        vm.isValid = false;
                        vm.isSending = false;
                    });

                    if(Object.prototype.hasOwnProperty.call(window, 'dataLayer') && Array.isArray(window.dataLayer)) {
                        window.dataLayer.push({
                            'event': 'preview-material-selected',
                            'material': this.selected_product.sku,
                        });

                        window.dataLayer.push({
                            'event': 'productClick',
                            'ecommerce': {
                                'click': {
                                    'actionField': {'list': 'FreePreview'},
                                    'products': [{
                                        'name': this.selected_product.display_name,
                                        'id': this.selected_product.sku,
                                        'price': this.selected_product.price,
                                        'category': this.selected_product_group.name,
                                    }]
                                }
                            },
                            'eventCallback': function() {
                                // do nothing
                            }
                        });
                    }

                } else {
                    this.isValid = false;
                    UploadLog.log('product_next_without_selection', {
                        product_group: this.selected_product_group ? this.selected_product_group.name : null
                    });
                }
            },
            productGroupChanged: function() {
                this.selected_product = null;
            },
            productChanged: function() {
                this.redrawImage();
            },
            redrawImage: function() {
                const vm = this;
                const canvas = document.getElementById("previewCanvas");
                const canvasW = 1200; // canvas.getBoundingClientRect().width;
                const canvasH = 710; // canvas.getBoundingClientRect().height;
                const ctx = canvas.getContext("2d");

                ctx.clearRect(0, 0, canvasW, canvasH);

                let size = 100;
                if(this.selected_product !== null) {
                    size = this.selected_product.size; // * 2.54;
                }

                let transform = {
                    s: 200,
                    hMax: 150,
                    wMax: 200,
                }

                let boundary = {
                    x: 250,
                    y: 50,
                    w: 540,
                    h: 400
                };

                let backgroundImage = new Image();
                backgroundImage.src = uploaderAssetBaseUrl + 'images/background.jpg';
                backgroundImage.onload = function() {
                    ctx.drawImage(backgroundImage, 0, 0);

                    let customerImage = new Image();
                    customerImage.src = vm.$store.getters.header_url;
                    customerImage.onload = function() {
                        let position = {
                            x: boundary.x, // positionX
                            y: boundary.y, // positionY
                            w: 0,  // width
                            h: 0,  // height
                            r: 1.0 // ratio
                        }

                        let isLandscape = false;
                        if(customerImage.naturalWidth > customerImage.naturalHeight) {
                            isLandscape = true;
                        }
                        const aspectRatio = customerImage.naturalWidth / customerImage.naturalHeight;

                        if(isLandscape) {
                            // The ratio between the max size of the boundary and the size of the selected product
                            if(size > transform.wMax) {
                                position.r = (transform.wMax / transform.s);
                            } else {
                                position.r = (size / transform.s);
                            }

                            // How big is the customer image in reference to the selected product?
                            position.w = boundary.w * position.r;
                            position.h = boundary.w / aspectRatio * position.r;
                        } else {
                            // The ratio between the max size of the boundary and the size of the selected product
                            if(size > transform.hMax) {
                                position.r = (transform.hMax / transform.s);
                            } else {
                                position.r = (size / transform.s);
                            }

                            // How big is the customer image in reference to the selected product?
                            position.w = boundary.h * aspectRatio * position.r;
                            position.h = boundary.h * position.r;
                        }

                        // Where to start drawing the customer image
                        position.x = boundary.x + (boundary.w - position.w) / 2;
                        position.y = boundary.y + (boundary.h - position.h) / 2;

                        // Debug info
                        // console.log(boundary, position, transform, size)

                        // Todo: Add shadow to customer image

                        // Draw image
                        ctx.drawImage(customerImage, position.x, position.y, position.w, position.h);
                    }
                }
            }
        },
        mounted() {
            var vm = this;

            if(Object.prototype.hasOwnProperty.call(window, 'dataLayer') && Array.isArray(window.dataLayer)) {
                window.dataLayer.push({
                    'event': 'preview-tile-images'
                });
            }

            this.$nextTick(() => {
                vm.$emit('scroll-to-app');
                vm.redrawImage();
            });
        },
        props: [
            'product_groups'
        ]
    }
</script>

<style scoped>
    * {
        box-sizing: border-box;
    }

    select {
        width: 100%;
        padding: 12px;
        border: 1px solid var(--uploader-line);
        border-radius: 4px;
        resize: vertical;
    }
</style>
